<template>
  <a
    v-if="externalHomeLink"
    id="home-button"
    class="header item"
    :href="externalHomeLink"
    target="_self"
  >
    <slot />
  </a>    
  <router-link
    :is="isSharedProject ? 'span' : 'router-link'"
    v-else
    id="home-button"
    :to="isSharedProject ? '' : '/'"
    :class="['header item', {disable: isSharedProject}]"
  >
    <slot />
  </router-link>    
</template>

<script>

export default {

  name: 'HomeButton',

  props: {
    externalHomeLink: {
      type: String,
      default: null,
    },
    isSharedProject: {
      type: Boolean,
      default: false,
    }
  }
};
</script>

<style lang="less">
#home-button.header {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  &> img {
    max-height: 30px;
  }
}

@media screen and (max-width: 725px) {
  #home-button.header {
    width: 100%;
    &> img {
      margin: 0;
      margin: auto;
      max-width: 100%;
    }
  }
}

.disable:hover {
  cursor: default !important;
  background-color: #373636 !important;
}
</style>